// eslint-disable-next-line
import { UserLayout, BasicLayout, RouteView, BlankLayout, PageView } from '@/layouts'
import { bxAnaalyse } from '@/core/icons'

export const asyncRouterMap = [
    {
        path: '/',
        name: 'banner',
        component: BasicLayout,
        meta: { title: '后台管理' },
        redirect: '/banner',
        children: [
            /* 会员管理*/
            {
                path: '/homepage',
                name: 'homepage',
                redirect: '/homepage/homepageone',
                component: RouteView,
                meta: { title: '统计中心', keepAlive: true, icon: 'team', permission: ['dashboard'] },
                children: [
                    {
                        path: '/homepage/homepageone',
                        name: 'homepageone',
                        component: () => import('@/views/homepage/homepageone'),
                        meta: { title: '注册统计', keepAlive: true, permission: ['dashboard'] }
                    },
                    {
                        path: '/homepage/homepagetop',
                        name: 'homepagetop',
                        component: () => import('@/views/homepage/homepagetop'),
                        meta: { title: '注册排行', keepAlive: true, permission: ['dashboard'] }
                    },
                    {
                        path: '/homepage/agent',
                        name: 'agent',
                        component: () => import('@/views/homepage/agent'),
                        meta: { title: '跳转UV统计', keepAlive: true, permission: ['dashboard'] }
                    },
                    {
                        path: '/homepage/agenttop',
                        name: 'agenttop',
                        component: () => import('@/views/homepage/agenttop'),
                        meta: { title: '跳转UV排行', keepAlive: true, permission: ['dashboard'] }
                    },
                    {
                        path: '/homepage/agentAccess',
                        name: 'agentAccess',
                        component: () => import('@/views/homepage/agentAccess'),
                        meta: { title: '访问UV统计', keepAlive: true, permission: ['dashboard'] }
                    },
                    {
                        path: '/homepage/agentAccesstop',
                        name: 'agentAccesstop',
                        component: () => import('@/views/homepage/agentAccesstop'),
                        meta: { title: '访问UV排行', keepAlive: true, permission: ['dashboard'] }
                    },
                ]
            },
            {
                path: '/provider',
                name: 'provider',
                redirect: '/provider/providerList',
                component: RouteView,
                meta: { title: '小程序管理', keepAlive: true, icon: 'team', permission: ['dashboard'] },
                children: [
                    {
                        path: '/provider/providerList',
                        name: 'provider',
                        component: () => import('@/views/provider/providerList'),
                        meta: { title: '上架列表', keepAlive: true, permission: ['dashboard'] }
                    },
                    {
                        path: '/provider/offList',
                        name: 'offlist',
                        component: () => import('@/views/provider/offList'),
                        meta: { title: '下架列表', keepAlive: true, permission: ['dashboard'] }
                    },
                    {
                        path: '/provider/addprovider',
                        name: 'addprovider',
                        component: () => import('@/views/provider/addprovider'),
                        meta: { title: '小程序(新增/编辑)', keepAlive: true, permission: ['dashboard'] },
                        hidden: true
                    },
                    {
                        path: '/provider/punishList',
                        name: 'punishList',
                        component: () => import('@/views/provider/punishList'),
                        meta: { title: '处罚列表', keepAlive: true, permission: ['dashboard'] }
                    },
                    {
                        path: '/jietu/jietuList',
                        name: 'jietuList',
                        component: () => import('@/views/jietu/jietuList'),
                        meta: { title: '首页截图列表', keepAlive: true, permission: ['dashboard'] },
                    },
                    {
                        path: '/jietu/jietuEdit',
                        name: 'jietuEdit',
                        component: () => import('@/views/jietu/jietuEdit'),
                        meta: { title: '首页截图(新增/编辑)', keepAlive: false, permission: ['dashboard'] },
                        hidden: true
                    },
                    {
                        path: '/rentplatform/rentplatformList',
                        name: 'rentplatform',
                        component: () => import('@/views/rentplatform/rentplatformList'),
                        meta: { title: '租机平台列表', keepAlive: true, permission: ['dashboard'] },
                    },
                    {
                        path: '/rentplatform/rentplatformEdit',
                        name: 'rentplatformEdit',
                        component: () => import('@/views/rentplatform/rentplatformEdit'),
                        meta: { title: '租机平台(新增/编辑)', keepAlive: false, permission: ['dashboard'] },
                        hidden: true
                    },
                ]
            },
            {
                path: '/banner',
                name: 'banner',
                redirect: '/banner/bannerList',
                component: RouteView,
                meta: { title: '轮播管理', keepAlive: true, icon: "picture", permission: ['dashboard'] },
                children: [
                    {
                        path: '/banner/bannerList',
                        name: 'bannerList',
                        component: () => import('@/views/banner/bannerList'),
                        meta: { title: '轮播列表', keepAlive: true, permission: ['dashboard'] },
                    },
                    {
                        path: '/banner/bannerEdit',
                        name: 'bannerEdit',
                        component: () => import('@/views/banner/bannerEdit'),
                        meta: { title: '轮播(新增/编辑)', keepAlive: false, permission: ['dashboard'] },
                        hidden: true
                    },
                ]
            },

            {
                path: '/problemList',
                name: 'problemList',
                redirect: '/problemList/index',
                component: RouteView,
                meta: { title: '问题分类', keepAlive: true, icon: 'team', permission: ['dashboard'] },
                children: [
                    {
                        path: '/problemList/index',
                        name: 'problemList',
                        component: () => import('@/views/problemList/index'),
                        meta: { title: '问题分类', keepAlive: true, permission: ['dashboard'] }
                    },
                    {
                        path: '/problemList/problemEdit',
                        name: 'problemEdit',
                        component: () => import('@/views/problemList/problemEdit'),
                        meta: { title: '问题分类(新增/编辑)', keepAlive: false, permission: ['dashboard'] },
                        hidden: true
                    },
                    {
                        path: '/problemList/indexcofig',
                        name: 'indexcofig',
                        component: () => import('@/views/problemList/indexcofig'),
                        meta: { title: '问题配置', keepAlive: true, permission: ['dashboard'] }
                    },
                ]
            },

            {
                path: '/commodity',
                name: 'commodity',
                redirect: '/commodity/commodityList',
                component: RouteView,
                meta: { title: '商品管理', keepAlive: true, icon: 'team', permission: ['dashboard'] },
                children: [
                    {
                        path: '/commodity/commodityList',
                        name: 'commodity',
                        component: () => import('@/views/commodity/commodityList'),
                        meta: { title: '商品列表', keepAlive: true, permission: ['dashboard'] }
                    },
                    {
                        path: '/commodity/commodityEdit',
                        name: 'commodityEdit',
                        component: () => import('@/views/commodity/commodityEdit'),
                        meta: { title: '商品(新增/编辑)', keepAlive: false, permission: ['dashboard'] },
                        hidden: true
                    },
                    {
                        path: '/commodity/GoodscatList',
                        name: 'GoodscatList',
                        component: () => import('@/views/commodity/GoodscatList'),
                        meta: { title: '首页分类', keepAlive: true, permission: ['dashboard'] }
                    },
                    {
                        path: '/commodity/GoodscatEdit',
                        name: 'GoodscatEdit',
                        component: () => import('@/views/commodity/GoodscatEdit'),
                        meta: { title: '首页分类(新增/编辑)', keepAlive: false, permission: ['dashboard'] },
                        hidden: true
                    },
                    {
                        path: '/commodity/GoodscatsList',
                        name: 'GoodscatsList',
                        component: () => import('@/views/commodity/GoodscatsList'),
                        meta: { title: '活动专区列表', keepAlive: true, permission: ['dashboard'] }
                    },
                    {
                        path: '/commodity/GoodscatsEdit',
                        name: 'GoodscatsEdit',
                        component: () => import('@/views/commodity/GoodscatsEdit'),
                        meta: { title: '活动专区(新增/编辑)', keepAlive: false, permission: ['dashboard'] },
                        hidden: true
                    },
                    {
                        path: '/commodity/catsList',
                        name: 'catsList',
                        component: () => import('@/views/commodity/catsList'),
                        meta: { title: '分类列表', keepAlive: true, permission: ['dashboard'] },
                    },
                    {
                        path: '/commodity/catsEdit',
                        name: 'catsEdit',
                        component: () => import('@/views/commodity/catsEdit'),
                        meta: { title: '分类(新增/编辑)', keepAlive: false, permission: ['dashboard'] },
                        hidden: true
                    },
                    {
                        path: '/commodity/discountsList',
                        name: 'discountsList',
                        component: () => import('@/views/commodity/discountsList'),
                        meta: { title: '折扣服务列表', keepAlive: true, permission: ['dashboard'] }
                    },
                    {
                        path: '/commodity/discountsEdit',
                        name: 'discountsEdit',
                        component: () => import('@/views/commodity/discountsEdit'),
                        meta: { title: '折扣服务(新增/编辑)', keepAlive: false, permission: ['dashboard'] },
                        hidden: true
                    },
                    {
                        path: '/commodity/newnessList',
                        name: 'newnessList',
                        component: () => import('@/views/commodity/newnessList'),
                        meta: { title: '成新度列表', keepAlive: true, permission: ['dashboard'] }
                    },
                    {
                        path: '/commodity/newnessEdit',
                        name: 'newnessEdit',
                        component: () => import('@/views/commodity/newnessEdit'),
                        meta: { title: '成新度(新增/编辑)', keepAlive: false, permission: ['dashboard'] },
                        hidden: true
                    },
                ]
            },
            {
                path: '/order',
                name: 'order',
                redirect: '/order/orderList',
                component: RouteView,
                meta: { title: '订单管理', keepAlive: true, icon: 'team', permission: ['dashboard'] },
                children: [
                    {
                        path: '/order/orderList',
                        name: 'order',
                        component: () => import('@/views/order/orderList'),
                        meta: { title: '订单列表', keepAlive: true, permission: ['dashboard'] }
                    },
                    {
                        path: '/order/orderTuiList',
                        name: 'orderTuiList',
                        component: () => import('@/views/order/orderTuiList'),
                        meta: { title: '退款原因列表', keepAlive: true, permission: ['dashboard'] }
                    },
                ]
            },
            {
                path: '/shop',
                name: 'shop',
                redirect: '/shop/shopList',
                component: RouteView,
                meta: { title: '店铺管理', keepAlive: true, icon: 'team', permission: ['dashboard'] },
                children: [
                    {
                        path: '/shop/shopList',
                        name: 'shop',
                        component: () => import('@/views/shop/shopList'),
                        meta: { title: '店铺列表', keepAlive: true, permission: ['dashboard'] }
                    },
                    {
                        path: '/shop/addShop',
                        name: 'addShop',
                        component: () => import('@/views/shop/addShop'),
                        meta: { title: '店铺(新增/编辑)', keepAlive: true, permission: ['dashboard'] },
                        hidden: true
                    },
                ]
            },
            /* 会员管理*/
            {
                path: '/member',
                name: 'member',
                redirect: '/member/memberList',
                component: RouteView,
                meta: { title: '会员管理', keepAlive: true, icon: 'team', permission: ['dashboard'] },
                children: [
                    {
                        path: '/member/memberList',
                        name: 'memberList',
                        component: () => import('@/views/member/memberList'),
                        meta: { title: '会员列表', keepAlive: true, permission: ['dashboard'] }
                    },
                    {
                        path: '/member/agentList',
                        name: 'agentList',
                        component: () => import('@/views/member/agentList'),
                        meta: { title: '跳转UV列表', keepAlive: true, permission: ['dashboard'] }
                    },
                    {
                        path: '/member/agentAccessList',
                        name: 'agentAccessList',
                        component: () => import('@/views/member/agentAccessList'),
                        meta: { title: '访问UV列表', keepAlive: true, permission: ['dashboard'] }
                    },

                ]
            },
            /*公告管理*/
            {
                path: '/news',
                name: 'news',
                redirect: '/news/newsList',
                component: RouteView,
                meta: { title: '意见反馈管理', keepAlive: true, icon: 'notification', permission: ['dashboard'] },
                children: [
                    {
                        path: '/news/newsList',
                        name: 'newsList',
                        component: () => import('@/views/news/newsList'),
                        meta: { title: '意见反馈列表', keepAlive: true, permission: ['dashboard'] }
                    },
                    /* {
                      path: '/news/newEdit',
                      name: 'newEdit',
                      component: () => import('@/views/news/newEdit'),
                      meta: { title: '新闻(新增/编辑)', keepAlive: false, permission: ['dashboard'] },
                      hidden: true
                    }, */
                ]
            },
            /*配置项管理*/
            {
                path: '/config',
                name: 'config',
                redirect: '/config/index',
                component: RouteView,
                meta: { title: '配置项管理', keepAlive: true, icon: 'setting', permission: ['dashboard'] },
                children: [
                    {
                        path: '/config/index',
                        name: 'configIndex',
                        component: () => import('@/views/config/index'),
                        meta: { title: '配置项', keepAlive: true, permission: ['dashboard'] }
                    },
                ]
            },
            //管理
            {
                path: '/power',
                name: 'power',
                redirect: '/power/admin',
                component: RouteView,
                meta: { title: '管理员', keepAlive: true, icon: "folder-open", permission: ['dashboard'] },
                children: [
                    {
                        path: '/power/admin',
                        name: 'admin',
                        component: () => import('@/views/power/admin'),
                        meta: { title: '管理员列表', keepAlive: true, permission: ['dashboard'] },
                    },
                    /* {
                         path: '/power/user',
                         name: 'user',
                         component: () => import('@/views/power/user'),
                         meta: { title: '用户组管理', keepAlive: true, permission: ['dashboard'] },
                     },*/
                    {
                        path: '/power/addUser',
                        name: 'addUser',
                        component: () => import('@/views/power/addUser'),
                        meta: { title: '新增用户组', keepAlive: false, permission: ['dashboard'] },
                        hidden: true
                    },
                ]
            },
            {
                path: '/Withdrawal',
                name: 'Withdrawal',
                redirect: '/Withdrawal/Withdrawallist',
                component: RouteView,
                meta: { title: '提现管理', keepAlive: true, icon: "folder-open", permission: ['dashboard'] },
                children: [
                    // {
                    //   path: '/Withdrawal/Withdrawallist',
                    //   name: 'Withdrawallist',
                    //   component: () => import('@/views/Withdrawal/Withdrawallist'),
                    //   meta: { title: '用户提现列表', keepAlive: true, permission: ['dashboard'] },
                    // },
                    {
                        path: '/Withdrawal/Withdrawallisttwo',
                        name: 'Withdrawallisttwo',
                        component: () => import('@/views/Withdrawal/Withdrawallisttwo'),
                        meta: { title: '商家提现列表', keepAlive: true, permission: ['dashboard'] },
                    },
                ]
            },
            {
                path: '/flowingWater',
                name: 'flowingWater',
                redirect: '/flowingWater/flowingWaterlist',
                component: RouteView,
                meta: { title: '财务列表', keepAlive: true, icon: "folder-open", permission: ['dashboard'] },
                children: [
                    {
                        path: '/flowingWater/flowingWaterlist',
                        name: 'flowingWaterlist',
                        component: () => import('@/views/flowingWater/flowingWaterlist'),
                        meta: { title: '财务流水', keepAlive: true, permission: ['dashboard'] },
                    },
                ]
            },
        ]
    },
    {
        path: '*', redirect: '/404', hidden: true
    }
]

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
    {
        path: '/user',
        component: UserLayout,
        redirect: '/user/login',
        hidden: true,
        children: [
            {
                path: 'login',
                name: 'login',
                component: () => import(/* webpackChunkName: "user" */ '@/views/user/Login')
            },
            {
                path: 'register',
                name: 'register',
                component: () => import(/* webpackChunkName: "user" */ '@/views/user/Register')
            },
            {
                path: 'register-result',
                name: 'registerResult',
                component: () => import(/* webpackChunkName: "user" */ '@/views/user/RegisterResult')
            }
        ]
    },

    {
        path: '/test',
        component: BlankLayout,
        redirect: '/test/home',
        children: [
            {
                path: 'home',
                name: 'TestHome',
                component: () => import('@/views/Home')
            }
        ]
    },
    {
        path: '/404',
        component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/404')
    }

]
